import { readApiErrorResponse } from "@/lib/api-error";
import { apiFetch } from "@/services/http/api-fetch";

export type StaffStudentQuiz = {
  quizId: string;
  lessonId: string;
  lessonTitle: string;
  passScorePct: number | null;
  timeLimitSec: number | null;
  state: "not_started" | "in_progress" | "expired" | "submitted";
  scorePct: number | null;
  passed: boolean | null;
  submittedAt: string | null;
};

const base = (courseId: string, userId: string) =>
  `/v1/instructor/courses/${courseId}/students/${userId}/quizzes`;

/** LRN-7: the student's attempt state for each quiz in the course (course staff only). */
export async function fetchStaffStudentQuizzes(
  courseId: string,
  userId: string,
): Promise<StaffStudentQuiz[]> {
  const res = await apiFetch(base(courseId, userId));
  if (!res.ok) throw await readApiErrorResponse(res);
  return ((await res.json()) as { data: { quizzes: StaffStudentQuiz[] } }).data.quizzes;
}

/** LRN-7 (D5): give the student a fresh attempt. */
export async function resetStaffStudentQuiz(
  courseId: string,
  userId: string,
  quizId: string,
): Promise<{ resetAttempts: number }> {
  const res = await apiFetch(`${base(courseId, userId)}/${quizId}/reset`, { method: "POST" });
  if (!res.ok) throw await readApiErrorResponse(res);
  return ((await res.json()) as { data: { resetAttempts: number } }).data;
}
